import { useCallback, useEffect, useRef, useState } from "react";
import { api } from "./api.js";
import { go } from "./router.js";
import { tg } from "./telegram.js";

export const CHANNEL_URL = "https://t.me/degensduel";

/**
 * Screens 72 and 73: open the channel in Telegram, and check membership when the player taps
 * "check again" or comes back to the app. Once they're in, battling picks up at Call Your Side.
 */
export function useChannelJoin() {
  const [checking, setChecking] = useState(false);
  const [notYet, setNotYet] = useState(false);

  // One check at a time: coming back can fire both "visible" and Telegram's "activated".
  const busy = useRef(false);
  const check = useCallback(async () => {
    if (busy.current) return;
    busy.current = true;
    setChecking(true);
    try {
      const r = await api<{ member: boolean }>("/v1/channel/check", { method: "POST" });
      if (r.member) {
        tg?.HapticFeedback?.notificationOccurred("success");
        go("App10", true);
      } else setNotYet(true);
    } catch {
      setNotYet(true);
    } finally {
      busy.current = false;
      setChecking(false);
    }
  }, []);

  // Coming back from the channel: browsers report it as visibility, Telegram as "activated".
  useEffect(() => {
    const onBack = () => document.visibilityState === "visible" && void check();
    const onActivated = () => void check();
    document.addEventListener("visibilitychange", onBack);
    tg?.onEvent?.("activated", onActivated);
    return () => {
      document.removeEventListener("visibilitychange", onBack);
      tg?.offEvent?.("activated", onActivated);
    };
  }, [check]);

  const open = () => {
    if (tg?.openTelegramLink) tg.openTelegramLink(CHANNEL_URL);
    else window.open(CHANNEL_URL, "_blank");
  };

  return { open, check, checking, notYet };
}
